import { useRouter } from 'next/router';
import { formatFacets, getRealLocale } from 'utils/helpers';
import { getProductCategory as apiGetProductCategory } from 'services/product';
import useSWR from 'swr';

export default function useProducts(productCategoryId, initialData, page, selectedSort, selectedFilters) {
  const router = useRouter();
  const locale = getRealLocale(router.locale);
  const url = `${locale}/api/v1/taxonomy/${productCategoryId}/`;

  const fetcher = () =>
    apiGetProductCategory(locale, productCategoryId, page, selectedSort, selectedFilters).then((res) => res.data);

  const {
    data: productCategoryData,
    error,
    mutate,
    isValidating,
  } = useSWR(
    [
      url,
      locale,
      productCategoryId,
      JSON.stringify(page),
      JSON.stringify(selectedSort),
      JSON.stringify(selectedFilters),
    ],
    fetcher,
    {
      initialData,
      revalidateOnFocus: false, // ✅ Keep this false
      revalidateOnReconnect: false, // ✅ Also set this false
      revalidateIfStale: false, // ✅ Prevent stale revalidation
      revalidateOnMount: false, // ✅ Don't revalidate on mount if data exists
      dedupingInterval: 60000, // Prevent duplicate requests
      onSuccess: (data, key, config) => {
        console.log('Data revalidated at:', new Date().toISOString());
      },
    }
  );

  return {
    mutate,
    url,
    productCategoryData: productCategoryData
      ? { ...productCategoryData, facets: formatFacets(productCategoryData?.facets) }
      : { ...initialData, facets: formatFacets(initialData?.facets) },
    error,
    isValidating,
  };
}
